import { map, pipe, prop, sortBy, uniqBy } from 'ramda'
import {
  rentInvoiceCategories,
  inspectionInvoiceCategories,
  depositInvoiceCategories,
  utilitiesInvoiceCategories,
  leaseStatuses,
  leaseType,
} from './constants'

export const getInvoiceTypesForSelect = pipe(
  map(({ name, value }: { name: string; value: string }) => {
    if (rentInvoiceCategories.includes(value)) {
      return { label: 'Rent', value: 'Rent' }
    } else if (inspectionInvoiceCategories.includes(value)) {
      return { label: 'Inspection', value: 'Inspection' }
    } else if (depositInvoiceCategories.includes(value)) {
      return { label: 'Deposit', value: 'Deposit' }
    } else if (utilitiesInvoiceCategories.includes(value)) {
      return { label: 'Utilities', value: 'Utilities' }
    } else {
      return { label: name, value }
    }
  }),
  uniqBy(prop('label')),
  sortBy((item: { label: string; value: string }) => {
    const priorityOrder = ['Rent', 'Utilities', 'Deposit']
    const index = priorityOrder.indexOf(item.label)
    // If item is in priority list, use its index with a prefix to ensure it comes first
    // Otherwise, use a prefix plus the label for alphabetical sorting
    return index !== -1 ? `0${index}` : `1${item.label}`
  }),
)

export const getInvoiceTypesFromGroups = (invoiceGroups: Array<{ value: string }>) => {
  const allTypes: string[] = []

  invoiceGroups.forEach(({ value }) => {
    switch (value) {
      case 'Rent':
        allTypes.push(...rentInvoiceCategories)
        break
      case 'Inspection':
        allTypes.push(...inspectionInvoiceCategories)
        break
      case 'Deposit':
        allTypes.push(...depositInvoiceCategories)
        break
      case 'Utilities':
        allTypes.push(...utilitiesInvoiceCategories)
        break
      default:
        allTypes.push(value)
        break
    }
  })

  return allTypes
}

export const leaseStatusesForSelect = () => leaseStatuses.map((status: string) => ({ label: status, value: status }))

export const leaseTypesForSelect = () => leaseType.map((type: string) => ({ label: type, value: type }))
